import { WireTransaction, TransactionRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchWireTransaction({ bearer }: { bearer: string }) {
  const [fetchingWireTransaction, setFetchingWireTransaction] = useState(false);
  const [wireTransaction, setWireTransaction] = useState<WireTransaction>();

  async function fetchWireTransaction(params: TransactionRequest) {
    try {
      setFetchingWireTransaction(true);
      const res = await api.fetchWireTransaction(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setWireTransaction(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetchingWireTransaction(false);
    }
  }

  return { fetchingWireTransaction, wireTransaction, fetchWireTransaction };
}
